/* This file is autogenerated, see readme.md for instructions */
import WaitSvgIcon from '@bloomreach/banana-theme/icons/wait.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const WaitIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <WaitSvgIcon />
    </Icon>
  );
});

WaitIcon.displayName = 'WaitIcon';

export default WaitIcon;
